import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetStaticProps } from 'next';
import { useTranslations } from 'next-intl';

import { HomeComponents } from 'modules/home';
import { getAllUniversities, universitiesConst, UniversityTypes } from 'modules/universities';

import { NextHead } from 'components';

export default function Home() {
  const t = useTranslations();

  return (
    <>
      <NextHead title={t('meta.home.title')} description={t('meta.home.description')} />
      <div className="font-light">
        <HomeComponents />
      </div>
    </>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  await queryClient.prefetchQuery({
    queryKey: [universitiesConst.queryKeys.ALL_UNIVERSITIES, { type: UniversityTypes.PRIVATE, size: 6 }],
    queryFn: getAllUniversities({ type: UniversityTypes.PRIVATE, size: 6 })
  });

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      messages: (await import(`../messages/${locale}.json`)).default
    },
    revalidate: 604800
  };
};
